import { defaultFAQ } from '../constants/editFAQ';
import { IFAQ, IResponseFAQ } from '../types/editFAQ';
import { TBooleanInNumber } from '~/types/main';

export const FAQCast = (data: IResponseFAQ): IFAQ => {
  return {
    id: Number(data.id || defaultFAQ.id),
    sort: Number(data.order || defaultFAQ.sort),
    question: {
      en: String(data.description?.en?.question || defaultFAQ.question.en),
      ar: String(data.description?.ar?.question || defaultFAQ.question.ar),
    },
    answer: {
      en: String(data.description?.en?.answer || defaultFAQ.answer.en),
      ar: String(data.description?.ar?.answer || defaultFAQ.answer.ar),
    },
    status: Number(data.status || defaultFAQ.status) as TBooleanInNumber,
  };
};

export const getFAQParams = (data: IFAQ) => {
  return {
    id: data.id,
    order: data.sort,
    description: {
      en: {
        question: data.question.en,
        answer: data.answer.en,
      },
      ar: {
        question: data.question.ar,
        answer: data.answer.ar,
      },
    },
    status: data.status,
  };
};
